import { useSelector } from "react-redux";
import { hasPermission, checkIsAdmin, PermissionId, ObjectTarget, } from "../../../app/permissions";
import { selectUser } from "../../../redux/user/userSlice";
import FragmentCardContent from "../../../features/base/FragmentCardContent";
import { getImagesUrl } from "../../../redux/common";
import { SchoolInfo } from "../../../redux/school/schoolSlice";
import { useEffect, useMemo, useState } from "react";
import { retrieveConversationList, RetrieveConversationListRequest, selectConversationList } from "../../../redux/conversation/conversationListSlice";
import { useAppDispatch } from "../../../app/hooks";
import { ConversationInfo } from "../../../redux/conversation/conversationSlice";
import { Box, Stack } from "@mui/material";
import { DptoInfo } from "../../../redux/dpto/dptoSlice";
import { ConversationListContainer } from "../../../features/conversation/ConversationListContainer";
import { MessagesScreen } from "../../../features/conversation/messages/MessagesScreen";
import { getElementHeight } from "../../../app/utils";
import { NamedObject } from "../../../redux/object/namedObject";

interface DptoConversationProps {
    school: SchoolInfo;
    dpto: DptoInfo;
}

export const DptoConversation = (props: DptoConversationProps) => {
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const conversationList = useSelector(selectConversationList);
    const [selectedConversation, setSelectedConversation] = useState<ConversationInfo | undefined>(undefined);

    const isAdmin = useMemo(() => checkIsAdmin(user.priza.info), [user.priza.info]);
    const me = useMemo((): NamedObject => {
        return NamedObject.dpto(props.dpto);
    }, [props.dpto]);
    const hasMessages = useMemo(
        () => isAdmin ||
            hasPermission(user.priza.info, PermissionId.DPTO_ADMIN, props.dpto.id) ||
            hasPermission(user.priza.info, PermissionId.DPTO_MESSAGE, props.dpto.id),
        [user.priza.info, props.dpto.id]);

    useEffect(() => {
        if (hasMessages) {
            const request: RetrieveConversationListRequest = {
                objectTarget: ObjectTarget.DPTO,
                targetId: `${props.dpto.id}`,
            };
            dispatch(retrieveConversationList(request));
        }
    }, [hasMessages, conversationList, user, props.dpto.id]);


    if (!hasMessages) {
        return <FragmentCardContent
            image={`${getImagesUrl()}/forbidden.webp`}
            title="Messagens"
            description="Sem permissões para enviar mesnagem por este departamento."
        />;
    }

    const topHeight = getElementHeight("top-bar");
    const appNameHeight = getElementHeight("app-name");
    const appControlHeight = getElementHeight("app-control");
    const messageHeight = window.innerHeight - (2 + topHeight + appNameHeight + appControlHeight);

    return <Stack direction="row" spacing={0}>
        <Box id='contacts' sx={{ width: "400px", minWidth: "400px", maxWidth: "400px" }}>
            <ConversationListContainer
                me={me} 
                school={props.school} 
                dpto={props.dpto}
                height={messageHeight} 
            />
        </Box>
        <Box id='conversation'  sx={{ width: "100%" }}>
            <MessagesScreen height={messageHeight} 
                // me={me} 
                // schoolId={props.dpto.schoolId}
            />
        </Box>
    </Stack>;

};